module.exports = __webpack_public_path__ + "img/phemex-desktop.c7d95ad2.png";